import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
// import './Accordion.css';
import {
  HomeUpdatedonedev,
  HomeUpdatedtwodev,
  HomeUpdatedthreedev,
  HomeUpdatedfourdev,
  HomeUpdatedfivedev,
  HomeUpdatedsixdev,
  HomeUpdatedsevendev,
  HomeUpdatedeightdev,
  discoveryBackground,
  HomeUpdatedArrowIcon,
} from "../../../../app-constants";

const AccordionItem = ({
  title,
  icon,
  contentMainTitle,
  contentMainContent,
  contentTitle,
  content,
  Link,
  isOpen,
  onToggle,
}) => {
  return (
    <div className="card">
      <div
        className={`card-header ${isOpen ? "active" : ""}`}
        onClick={onToggle}
      >
        {title}
        <div className="svg-arrow-icon d-block d-lg-none">
          {HomeUpdatedArrowIcon}
        </div>
      </div>
      <div className={`collapse ${isOpen ? "show width" : "width"}`}>
        <div className="card-body">
          <div className="discovery-bg">{discoveryBackground}</div>
          <div className="arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="36"
              fill="none"
              viewBox="0 0 20 36"
            >
              <path
                stroke="#F47A1F"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
                d="M1.893 2.377l15.62 15.62-15.62 15.62"
              ></path>
            </svg>
          </div>
          <div
            className="main-title"
            dangerouslySetInnerHTML={{ __html: contentMainTitle }}
          />
          <div className="main-title-content">
            <p dangerouslySetInnerHTML={{ __html: contentMainContent }} />
          </div>
          <div class="content-wrap">
            <div class="icon">{icon}</div>
            <h3
              className="title"
              dangerouslySetInnerHTML={{ __html: contentTitle }}
            />
            <p dangerouslySetInnerHTML={{ __html: content }} />
            {/* <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              {{ __html: Link }}
            </Link> */}
          </div>
        </div>
      </div>
    </div>
  );
};

function DiscoveryAcc() {
  const [activeIndex, setActiveIndex] = useState(0);

  // const handleToggle = (index) => {
  //   setActiveIndex(activeIndex === index ? null : index);
  // };

  const handleToggle = (index) => {
    // Set activeIndex to the clicked index if it's different from the current active index
    setActiveIndex(activeIndex === index ? activeIndex : index);
  };

  return (
    <section className="tekrevol-home-discovery overflow-x-hidden b2b-portal-seamless">
      <div className="accordion width" id="accordionHorizontalExample">
        <AccordionItem
          title="Strategic Planning"
          contentMainTitle="Precision-Engineered Mobile App Development Cycle</span>"
          contentMainContent="TekRevol is a leading mobile app development company in Bahrain, delivering high-performance, scalable solutions through a fine-tuned and transparent process. We adopt a collaborative approach, ensuring our clients are integral to each phase of development, enhancing the app’s success in the market."
          icon={HomeUpdatedonedev}
          contentTitle="Strategic Planning"
          content="Conducting a deep dive into your business requirements, market needs, and user expectations. This stage involves meticulous planning, technology stack selection, and defining KPIs to ensure alignment with your business goals."
          // Link="Talk to Our Experts"
          isOpen={activeIndex === 0}
          onToggle={() => handleToggle(0)}
        />
        <AccordionItem
          title="UX/UI Design"
          contentMainTitle="Precision-Engineered Mobile App Development Cycle</span>"
          contentMainContent="TekRevol is a leading mobile app development company in Bahrain, delivering high-performance, scalable solutions through a fine-tuned and transparent process. We adopt a collaborative approach, ensuring our clients are integral to each phase of development, enhancing the app’s success in the market."
          icon={HomeUpdatedtwodev}
          contentTitle="UX/UI Design"
          content="Designing user interfaces and experiences that drive engagement and retention. Our engineering process incorporates wireframes, high-fidelity designs, and interactive mockups, ensuring every detail is optimized for user interaction."
          isOpen={activeIndex === 1}
          onToggle={() => handleToggle(1)}
        />
        <AccordionItem
          title="Architecture Setup"
          contentMainTitle="Precision-Engineered Mobile App Development Cycle</span>"
          contentMainContent="TekRevol is a leading mobile app development company in Bahrain, delivering high-performance, scalable solutions through a fine-tuned and transparent process. We adopt a collaborative approach, ensuring our clients are integral to each phase of development, enhancing the app’s success in the market."
          icon={HomeUpdatedthreedev}
          contentTitle="Architecture Setup"
          content="Developing a resilient and scalable architecture tailored to your app’s future growth. This includes setting up cloud environments, API management, and secure database configurations to support seamless integration and optimal performance."
          isOpen={activeIndex === 2}
          onToggle={() => handleToggle(2)}
        />
        <AccordionItem
          title="Agile Development"
          contentMainTitle="Precision-Engineered Mobile App Development Cycle</span>"
          contentMainContent="TekRevol is a leading mobile app development company in Bahrain, delivering high-performance, scalable solutions through a fine-tuned and transparent process. We adopt a collaborative approach, ensuring our clients are integral to each phase of development, enhancing the app’s success in the market."
          icon={HomeUpdatedfourdev}
          contentTitle="Agile Development"
          content="Implementing an iterative development cycle, where we focus on modular code, continuous integration, and real-time performance tuning. Our Bahrain-based development team ensures that each build is fully optimized for speed and reliability."
          isOpen={activeIndex === 3}
          onToggle={() => handleToggle(3)}
        />
        <AccordionItem
          title="Quality Testing"
          contentMainTitle="Precision-Engineered Mobile App Development Cycle</span>"
          contentMainContent="TekRevol is a leading mobile app development company in Bahrain, delivering high-performance, scalable solutions through a fine-tuned and transparent process. We adopt a collaborative approach, ensuring our clients are integral to each phase of development, enhancing the app’s success in the market."
          icon={HomeUpdatedfivedev}
          contentTitle="Quality Testing"
          content="Executing a thorough testing regimen that includes unit testing, integration testing, and user acceptance testing. We also ensure compliance with Bahrain’s data protection laws, delivering a secure and robust application ready for deployment."
          isOpen={activeIndex === 4}
          onToggle={() => handleToggle(4)}
        />
        <AccordionItem
          title="Launch & Support"
          contentMainTitle="Precision-Engineered Mobile App Development Cycle</span>"
          contentMainContent="TekRevol is a leading mobile app development company in Bahrain, delivering high-performance, scalable solutions through a fine-tuned and transparent process. We adopt a collaborative approach, ensuring our clients are integral to each phase of development, enhancing the app’s success in the market."
          icon={HomeUpdatedsixdev}
          contentTitle="Launch & Support"
          content="Facilitating a smooth deployment process with zero downtime. Post-launch, our team provides lifecycle management services, including real-time monitoring, performance analytics, and continuous improvements to keep your app ahead in the market."
          isOpen={activeIndex === 5}
          onToggle={() => handleToggle(5)}
        />
      </div>
    </section>
  );
}

export default DiscoveryAcc;
